import { Button, ButtonProps } from '@prenuvo/halo-foundation';

import { FCT } from '@/i18n';

import { useReportIssue } from '../use-report-issue.hook';

type ReportIssueButtonProps = {
  buttonSize?: 'md' | 'sm';
  className?: ButtonProps['className'];
};

export function ReportIssueButton({ buttonSize = 'sm', className }: ReportIssueButtonProps) {
  const { onToggleReportIssue } = useReportIssue();

  return (
    <Button
      className={{ root: className?.root, text: className?.text }}
      data-testid="report-issue-button"
      onClick={() => onToggleReportIssue(true)}
      size={buttonSize}
      variant="text"
    >
      {FCT.REPORTING.REPORT_ISSUE.ACTIONS.REPORT_ISSUE}
    </Button>
  );
}
